module.exports = "https://trybtryb-legacy.web.app/img/periwinkle.2de3c45a.webp";